/**
 * @prettier
 * THIS STORE IS AUTO-GENERATED - DO NOT MODIFY ANYTHING IN HERE!
 */
import {
  apiEffortEntriesGetCollection,
  apiEffortEntriesPost,
  apiEffortEntriesIdDelete,
  apiEffortEntriesIdGet,
  apiEffortEntriesIdPut,
  apiEffortEntriesByPartnerPartnerGetCollection,
  apiEffortEntriesRecursiveEffortidGetCollection,
  apiEffortEntriesShortGetCollection,
  apiEffortEntriesUnsyncedGetCollection,
} from "@/api";
import { useLogger, type Logger } from "@/composables/useLogger";
import { useMercure, type MercureUnsubscriber } from "@/composables/useMercure";
import { type StoreCache, useStoreCache } from "@/composables/useStoreCache";
import { fromIri, iri2id, isIri } from "@/helpers/iri";
import { useEventBus } from "@vueuse/core";
import { Semaphore } from "async-mutex";
import { keyBy, uniq, without, forEach, fromPairs } from "lodash-es";
import { AxiosResponse, AxiosError } from "axios";
import {
  checkIriArray,
  HydraToPagination,
  HydraToIriDictionary,
  HydraToIriMap,
  filterAsync,
  arrayToObject,
  RequestOptions,
  defaultRequestOptionsMerge,
  storeMethodArgumentsCompatibilityLayer,
} from "@/stores";
import { defineStore, DefineStoreOptions, StateTree, Store } from "pinia";
import type {
  ApiEffortEntriesGetCollectionData,
  ApiEffortEntriesGetCollectionResponse,
  ApiEffortEntriesPostData,
  ApiEffortEntriesPostResponse,
  ApiEffortEntriesIdDeleteData,
  ApiEffortEntriesIdDeleteResponse,
  ApiEffortEntriesIdGetData,
  ApiEffortEntriesIdGetResponse,
  ApiEffortEntriesIdPutData,
  ApiEffortEntriesIdPutResponse,
  ApiEffortEntriesByPartnerPartnerGetCollectionData,
  ApiEffortEntriesByPartnerPartnerGetCollectionResponse,
  ApiEffortEntriesRecursiveEffortidGetCollectionData,
  ApiEffortEntriesRecursiveEffortidGetCollectionResponse,
  ApiEffortEntriesShortGetCollectionData,
  ApiEffortEntriesShortGetCollectionResponse,
  ApiEffortEntriesUnsyncedGetCollectionData,
  ApiEffortEntriesUnsyncedGetCollectionResponse,
} from "@/api";

import type { Pagination, JsonldCollection } from "@/stores";

//#region Live stream handler
useEventBus("mercure-connected").on(() => {
  const mercureUnsubscriber: MercureUnsubscriber = useMercure().subscribe<{
    "@id": string;
  }>("EffortEntry", async (data: { "@id": string }) => {
    if (data["@id"])
      await useGeneratedEffortEntryStore().$cache.set(
        iri2id(data["@id"]),
        data,
        "item",
      );
  });
  useEventBus("mercure-disconnected").once(() => {
    // this.$logger.debug(`unsubscribed to real-time updates`);
    mercureUnsubscriber();
  });
});
//#endregion Live stream handler
const storeId = "effort-entry-store.gen";
const logger = useLogger(storeId);
//const cache = useStoreCache(storeId)
export const useGeneratedEffortEntryStore = defineStore(storeId, {
  state: () => ({
    loading: false,
    $iriPrefix: "/api/effort_entries",
    $cache: useStoreCache(storeId),
  }),
  actions: {
    /*
     * GetCnt: 1
     * CollectionCnt: 5
     * PatchCnt: 0
     * PostCnt: 1
     * PutCnt: 1
     * DeleteCnt: 1
     */

    async fetchById<ThrowGlobalError extends boolean = true>(
      id: string,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(arguments, "fetchBy");
      options = defaultRequestOptionsMerge(options);
      if (options?.forceRefresh)
        await this.$cache.delete(
          id + ":" + (options?.context ?? "default"),
          "item",
        );
      return await this.$cache.getOrCreate<ApiEffortEntriesIdGetResponse>(
        id + ":" + (options?.context ?? "default"),
        async () => {
          const promise = (await apiEffortEntriesIdGet<ThrowGlobalError>({
            ...(options?.context
              ? { query: { context: options?.context } }
              : {}),
            path: { id: id as unknown as string },
            throwOnError: options.throwGlobalError,
          })) as AxiosResponse<ApiEffortEntriesIdGetResponse>;
          if (!(promise.status >= 200 && promise.status < 300))
            throw new Error("ERROR_SKIP_CACHE", { cause: promise });
          return promise.data;
        },
        "item",
      );
    },
    async fetchByIdRaw<ThrowGlobalError extends boolean = true>(
      id: string,
      context?: string,
    ) {
      return await apiEffortEntriesIdGet<ThrowGlobalError>({
        ...(context ? { query: { context } } : {}),
        path: { id: id },
      });
    },

    fetchByIri<ThrowGlobalError extends boolean = true>(
      iri: string,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(arguments, "fetchByIri");
      options = defaultRequestOptionsMerge(options);
      if (!iri) {
        debugger;
        throw new Error("No Iri");
      }
      const id = iri2id(iri, false);
      return this.fetchById<ThrowGlobalError>(id, options);
    },

    /**
{"name":"apiEffortEntriesGetCollection","tag":"EffortEntry","storeName":"EffortEntry","requestType":"ApiEffortEntriesGetCollectionData","responseType":"ApiEffortEntriesGetCollectionResponse","errorType":"unknown","apiFunctionName":"apiEffortEntriesGetCollection","requestImportName":"ApiEffortEntriesGetCollectionData","responseImportName":"ApiEffortEntriesGetCollectionResponse","actionType":"collection","actionName":"fetchAll","friendlyName":"fetchAll","suffix":""}
*/
    async findAll<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortEntriesGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ): Promise<Ref<ApiEffortEntriesGetCollectionResponse["hydra:member"]>> {
      options = storeMethodArgumentsCompatibilityLayer(arguments, "findAll");
      options = defaultRequestOptionsMerge(options);
      payload ??= {};
      payload.query ??= {};
      payload.query.page ??= 1;
      payload.query.itemsPerPage ??= 100;
      if (payload.query.itemsPerPage === 0) return ref([]);
      if (options?.context) payload.query.context = options.context;
      if (options?.forceRefresh)
        await this.$cache.delete(payload, "collection");
      const res = await this.$cache.getOrCreate<
        ApiEffortEntriesGetCollectionResponse["hydra:member"]
      >(
        payload,
        async () => {
          const promise =
            (await apiEffortEntriesGetCollection<ThrowGlobalError>({
              ...payload,
              ...(options?.context
                ? { query: { context: options?.context } }
                : {}),
              throwOnError: options.throwGlobalError,
            })) as AxiosResponse<
              ApiEffortEntriesGetCollectionResponse["hydra:member"]
            >;
          if (!(promise.status >= 200 && promise.status < 300))
            throw new Error("ERROR_SKIP_CACHE", { cause: promise });
          return promise.data["hydra:member"]
            ? Array.from(promise.data["hydra:member"])
            : [];
        },
        "collection",
      );
      if (typeof res.value === "object" && !payload.query["properties[]"]) {
        const data =
          res.value as ApiEffortEntriesGetCollectionResponse["hydra:member"];
        await Promise.all(
          data.map((jsonld) => {
            if (jsonld["@id"]) {
              return this.$cache.set(iri2id(jsonld["@id"]), jsonld, "item");
            }
          }),
        );
      }
      return res as Ref<ApiEffortEntriesGetCollectionResponse["hydra:member"]>;
    },
    async findAllHydra<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortEntriesGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ): Promise<Ref<ApiEffortEntriesGetCollectionResponse>> {
      payload ??= {};
      payload.query ??= {};
      payload.query.page ??= 1;
      payload.query.itemsPerPage ??= 100;
      if (options?.context) payload.query.context = options.context;
      if (options?.forceRefresh) await this.$cache.delete(payload, "hydra");
      const res =
        await this.$cache.getOrCreate<ApiEffortEntriesGetCollectionResponse>(
          payload,
          async () => {
            const d = await apiEffortEntriesGetCollection<ThrowGlobalError>(
              payload,
            ).then((d) => d.data);
            return d;
          },
          "hydra",
        );
      if (typeof res.value === "object" && !payload.query["properties[]"]) {
        const data = res.value["hydra:member"];
        await Promise.all(
          data.map((jsonld) => {
            if (jsonld["@id"]) {
              return this.$cache.set(iri2id(jsonld["@id"]), jsonld, "item");
            }
          }),
        );
      }
      return res;
    },
    async find<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortEntriesGetCollectionData,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(arguments, "find");
      if (!payload) payload = { query: {} };
      if (!payload.query) payload.query = {};
      payload.query.page = 1;
      payload.query.itemsPerPage = 1;
      if (options?.context) payload.query.context = options.context;
      const res = await this.findAll<ThrowGlobalError>(payload, options);
      if (res.value.length > 1)
        logger.warn("Find() returned more than one result!");
      return computed(() => (res.value.length > 0 ? res.value[0] : undefined));
    },
    /* {"name":"apiEffortEntriesGetCollection","tag":"EffortEntry","storeName":"EffortEntry","requestType":"ApiEffortEntriesGetCollectionData","responseType":"ApiEffortEntriesGetCollectionResponse","errorType":"unknown","apiFunctionName":"apiEffortEntriesGetCollection","requestImportName":"ApiEffortEntriesGetCollectionData","responseImportName":"ApiEffortEntriesGetCollectionResponse","actionType":"collection","actionName":"fetchAll","friendlyName":"fetchAll","suffix":""} */
    async findAllWithPagination<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortEntriesGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "findAllWithPagination",
      );
      const result = await this.findAllHydra<ThrowGlobalError>(
        payload,
        options,
      );
      return HydraToPagination<(typeof result.value)["hydra:member"][number]>(
        result,
      );
    },
    async findAllAsIriDictionary<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortEntriesGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "findAllAsIriDictionary",
      );
      const result = await this.findAllHydra<ThrowGlobalError>(
        payload,
        options,
      );
      return HydraToIriDictionary<
        (typeof result.value)["hydra:member"][number]
      >(result);
    },
    async findAllAsMap<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortEntriesGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "findAllAsMap",
      );
      const result = await this.findAllHydra<ThrowGlobalError>(
        payload,
        options,
      );
      return HydraToIriMap<(typeof result.value)["hydra:member"][number]>(
        result,
      );
    },
    /**
{"name":"apiEffortEntriesByPartnerPartnerGetCollection","tag":"EffortEntry","storeName":"EffortEntry","requestType":"ApiEffortEntriesByPartnerPartnerGetCollectionData","responseType":"ApiEffortEntriesByPartnerPartnerGetCollectionResponse","errorType":"unknown","apiFunctionName":"apiEffortEntriesByPartnerPartnerGetCollection","requestImportName":"ApiEffortEntriesByPartnerPartnerGetCollectionData","responseImportName":"ApiEffortEntriesByPartnerPartnerGetCollectionResponse","actionType":"collection","actionName":"fetchAll","friendlyName":"fetchAll","identifierName":"partner","identifierType":"string","suffix":"ByPartnerPartner","identifierNameCapitalized":"Partner"}
*/
    async findAllByPartnerPartner<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortEntriesByPartnerPartnerGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ): Promise<
      Ref<ApiEffortEntriesByPartnerPartnerGetCollectionResponse["hydra:member"]>
    > {
      options = storeMethodArgumentsCompatibilityLayer(arguments, "findAll");
      options = defaultRequestOptionsMerge(options);
      payload ??= {};
      payload.query ??= {};
      payload.query.page ??= 1;
      payload.query.itemsPerPage ??= 100;
      if (payload.query.itemsPerPage === 0) return ref([]);
      if (options?.context) payload.query.context = options.context;
      if (options?.forceRefresh)
        await this.$cache.delete(payload, "collection");
      const res = await this.$cache.getOrCreate<
        ApiEffortEntriesByPartnerPartnerGetCollectionResponse["hydra:member"]
      >(
        payload,
        async () => {
          const promise =
            (await apiEffortEntriesByPartnerPartnerGetCollection<ThrowGlobalError>(
              {
                ...payload,
                ...(options?.context
                  ? { query: { context: options?.context } }
                  : {}),
                throwOnError: options.throwGlobalError,
              },
            )) as AxiosResponse<
              ApiEffortEntriesByPartnerPartnerGetCollectionResponse["hydra:member"]
            >;
          if (!(promise.status >= 200 && promise.status < 300))
            throw new Error("ERROR_SKIP_CACHE", { cause: promise });
          return promise.data["hydra:member"]
            ? Array.from(promise.data["hydra:member"])
            : [];
        },
        "collection",
      );
      if (typeof res.value === "object" && !payload.query["properties[]"]) {
        const data =
          res.value as ApiEffortEntriesByPartnerPartnerGetCollectionResponse["hydra:member"];
        await Promise.all(
          data.map((jsonld) => {
            if (jsonld["@id"]) {
              return this.$cache.set(iri2id(jsonld["@id"]), jsonld, "item");
            }
          }),
        );
      }
      return res as Ref<
        ApiEffortEntriesByPartnerPartnerGetCollectionResponse["hydra:member"]
      >;
    },
    async findAllByPartnerPartnerHydra<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortEntriesByPartnerPartnerGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ): Promise<Ref<ApiEffortEntriesByPartnerPartnerGetCollectionResponse>> {
      payload ??= {};
      payload.query ??= {};
      payload.query.page ??= 1;
      payload.query.itemsPerPage ??= 100;
      if (options?.context) payload.query.context = options.context;
      if (options?.forceRefresh) await this.$cache.delete(payload, "hydra");
      const res =
        await this.$cache.getOrCreate<ApiEffortEntriesByPartnerPartnerGetCollectionResponse>(
          payload,
          async () => {
            const d =
              await apiEffortEntriesByPartnerPartnerGetCollection<ThrowGlobalError>(
                payload,
              ).then((d) => d.data);
            return d;
          },
          "hydra",
        );
      if (typeof res.value === "object" && !payload.query["properties[]"]) {
        const data = res.value["hydra:member"];
        await Promise.all(
          data.map((jsonld) => {
            if (jsonld["@id"]) {
              return this.$cache.set(iri2id(jsonld["@id"]), jsonld, "item");
            }
          }),
        );
      }
      return res;
    },
    async findByPartnerPartner<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortEntriesByPartnerPartnerGetCollectionData,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(arguments, "find");
      if (!payload) payload = { query: {} };
      if (!payload.query) payload.query = {};
      payload.query.page = 1;
      payload.query.itemsPerPage = 1;
      if (options?.context) payload.query.context = options.context;
      const res = await this.findAll<ThrowGlobalError>(payload, options);
      if (res.value.length > 1)
        logger.warn("Find() returned more than one result!");
      return computed(() => (res.value.length > 0 ? res.value[0] : undefined));
    },
    /* {"name":"apiEffortEntriesByPartnerPartnerGetCollection","tag":"EffortEntry","storeName":"EffortEntry","requestType":"ApiEffortEntriesByPartnerPartnerGetCollectionData","responseType":"ApiEffortEntriesByPartnerPartnerGetCollectionResponse","errorType":"unknown","apiFunctionName":"apiEffortEntriesByPartnerPartnerGetCollection","requestImportName":"ApiEffortEntriesByPartnerPartnerGetCollectionData","responseImportName":"ApiEffortEntriesByPartnerPartnerGetCollectionResponse","actionType":"collection","actionName":"fetchAll","friendlyName":"fetchAll","identifierName":"partner","identifierType":"string","suffix":"ByPartnerPartner","identifierNameCapitalized":"Partner"} */
    async findAllByPartnerPartnerWithPagination<
      ThrowGlobalError extends boolean = true,
    >(
      payload: ApiEffortEntriesByPartnerPartnerGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "findAllWithPagination",
      );
      const result = await this.findAllByPartnerPartnerHydra<ThrowGlobalError>(
        payload,
        options,
      );
      return HydraToPagination<(typeof result.value)["hydra:member"][number]>(
        result,
      );
    },
    async findAllByPartnerPartnerAsIriDictionary<
      ThrowGlobalError extends boolean = true,
    >(
      payload: ApiEffortEntriesByPartnerPartnerGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "findAllAsIriDictionary",
      );
      const result = await this.findAllByPartnerPartnerHydra<ThrowGlobalError>(
        payload,
        options,
      );
      return HydraToIriDictionary<
        (typeof result.value)["hydra:member"][number]
      >(result);
    },
    async findAllByPartnerPartnerAsMap<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortEntriesByPartnerPartnerGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "findAllAsMap",
      );
      const result = await this.findAllByPartnerPartnerHydra<ThrowGlobalError>(
        payload,
        options,
      );
      return HydraToIriMap<(typeof result.value)["hydra:member"][number]>(
        result,
      );
    },
    /**
{"name":"apiEffortEntriesRecursiveEffortidGetCollection","tag":"EffortEntry","storeName":"EffortEntry","requestType":"ApiEffortEntriesRecursiveEffortidGetCollectionData","responseType":"ApiEffortEntriesRecursiveEffortidGetCollectionResponse","errorType":"unknown","apiFunctionName":"apiEffortEntriesRecursiveEffortidGetCollection","requestImportName":"ApiEffortEntriesRecursiveEffortidGetCollectionData","responseImportName":"ApiEffortEntriesRecursiveEffortidGetCollectionResponse","actionType":"collection","actionName":"fetchAll","friendlyName":"fetchAll","identifierName":"effortid","identifierType":"string","suffix":"RecursiveEffortid","identifierNameCapitalized":"Effortid"}
*/
    async findAllRecursiveEffortid<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortEntriesRecursiveEffortidGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ): Promise<
      Ref<
        ApiEffortEntriesRecursiveEffortidGetCollectionResponse["hydra:member"]
      >
    > {
      options = storeMethodArgumentsCompatibilityLayer(arguments, "findAll");
      options = defaultRequestOptionsMerge(options);
      payload ??= {};
      payload.query ??= {};
      payload.query.page ??= 1;
      payload.query.itemsPerPage ??= 100;
      if (payload.query.itemsPerPage === 0) return ref([]);
      if (options?.context) payload.query.context = options.context;
      if (options?.forceRefresh)
        await this.$cache.delete(payload, "collection");
      const res = await this.$cache.getOrCreate<
        ApiEffortEntriesRecursiveEffortidGetCollectionResponse["hydra:member"]
      >(
        payload,
        async () => {
          const promise =
            (await apiEffortEntriesRecursiveEffortidGetCollection<ThrowGlobalError>(
              {
                ...payload,
                ...(options?.context
                  ? { query: { context: options?.context } }
                  : {}),
                throwOnError: options.throwGlobalError,
              },
            )) as AxiosResponse<
              ApiEffortEntriesRecursiveEffortidGetCollectionResponse["hydra:member"]
            >;
          if (!(promise.status >= 200 && promise.status < 300))
            throw new Error("ERROR_SKIP_CACHE", { cause: promise });
          return promise.data["hydra:member"]
            ? Array.from(promise.data["hydra:member"])
            : [];
        },
        "collection",
      );
      if (typeof res.value === "object" && !payload.query["properties[]"]) {
        const data =
          res.value as ApiEffortEntriesRecursiveEffortidGetCollectionResponse["hydra:member"];
        await Promise.all(
          data.map((jsonld) => {
            if (jsonld["@id"]) {
              return this.$cache.set(iri2id(jsonld["@id"]), jsonld, "item");
            }
          }),
        );
      }
      return res as Ref<
        ApiEffortEntriesRecursiveEffortidGetCollectionResponse["hydra:member"]
      >;
    },
    async findAllRecursiveEffortidHydra<
      ThrowGlobalError extends boolean = true,
    >(
      payload: ApiEffortEntriesRecursiveEffortidGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ): Promise<Ref<ApiEffortEntriesRecursiveEffortidGetCollectionResponse>> {
      payload ??= {};
      payload.query ??= {};
      payload.query.page ??= 1;
      payload.query.itemsPerPage ??= 100;
      if (options?.context) payload.query.context = options.context;
      if (options?.forceRefresh) await this.$cache.delete(payload, "hydra");
      const res =
        await this.$cache.getOrCreate<ApiEffortEntriesRecursiveEffortidGetCollectionResponse>(
          payload,
          async () => {
            const d =
              await apiEffortEntriesRecursiveEffortidGetCollection<ThrowGlobalError>(
                payload,
              ).then((d) => d.data);
            return d;
          },
          "hydra",
        );
      if (typeof res.value === "object" && !payload.query["properties[]"]) {
        const data = res.value["hydra:member"];
        await Promise.all(
          data.map((jsonld) => {
            if (jsonld["@id"]) {
              return this.$cache.set(iri2id(jsonld["@id"]), jsonld, "item");
            }
          }),
        );
      }
      return res;
    },
    async findRecursiveEffortid<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortEntriesRecursiveEffortidGetCollectionData,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(arguments, "find");
      if (!payload) payload = { query: {} };
      if (!payload.query) payload.query = {};
      payload.query.page = 1;
      payload.query.itemsPerPage = 1;
      if (options?.context) payload.query.context = options.context;
      const res = await this.findAll<ThrowGlobalError>(payload, options);
      if (res.value.length > 1)
        logger.warn("Find() returned more than one result!");
      return computed(() => (res.value.length > 0 ? res.value[0] : undefined));
    },
    /* {"name":"apiEffortEntriesRecursiveEffortidGetCollection","tag":"EffortEntry","storeName":"EffortEntry","requestType":"ApiEffortEntriesRecursiveEffortidGetCollectionData","responseType":"ApiEffortEntriesRecursiveEffortidGetCollectionResponse","errorType":"unknown","apiFunctionName":"apiEffortEntriesRecursiveEffortidGetCollection","requestImportName":"ApiEffortEntriesRecursiveEffortidGetCollectionData","responseImportName":"ApiEffortEntriesRecursiveEffortidGetCollectionResponse","actionType":"collection","actionName":"fetchAll","friendlyName":"fetchAll","identifierName":"effortid","identifierType":"string","suffix":"RecursiveEffortid","identifierNameCapitalized":"Effortid"} */
    async findAllRecursiveEffortidWithPagination<
      ThrowGlobalError extends boolean = true,
    >(
      payload: ApiEffortEntriesRecursiveEffortidGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "findAllWithPagination",
      );
      const result = await this.findAllRecursiveEffortidHydra<ThrowGlobalError>(
        payload,
        options,
      );
      return HydraToPagination<(typeof result.value)["hydra:member"][number]>(
        result,
      );
    },
    async findAllRecursiveEffortidAsIriDictionary<
      ThrowGlobalError extends boolean = true,
    >(
      payload: ApiEffortEntriesRecursiveEffortidGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "findAllAsIriDictionary",
      );
      const result = await this.findAllRecursiveEffortidHydra<ThrowGlobalError>(
        payload,
        options,
      );
      return HydraToIriDictionary<
        (typeof result.value)["hydra:member"][number]
      >(result);
    },
    async findAllRecursiveEffortidAsMap<
      ThrowGlobalError extends boolean = true,
    >(
      payload: ApiEffortEntriesRecursiveEffortidGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "findAllAsMap",
      );
      const result = await this.findAllRecursiveEffortidHydra<ThrowGlobalError>(
        payload,
        options,
      );
      return HydraToIriMap<(typeof result.value)["hydra:member"][number]>(
        result,
      );
    },
    /**
{"name":"apiEffortEntriesShortGetCollection","tag":"EffortEntry","storeName":"EffortEntry","requestType":"ApiEffortEntriesShortGetCollectionData","responseType":"ApiEffortEntriesShortGetCollectionResponse","errorType":"unknown","apiFunctionName":"apiEffortEntriesShortGetCollection","requestImportName":"ApiEffortEntriesShortGetCollectionData","responseImportName":"ApiEffortEntriesShortGetCollectionResponse","actionType":"collection","actionName":"fetchAll","friendlyName":"fetchAll","suffix":"Short"}
*/
    async findAllShort<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortEntriesShortGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ): Promise<
      Ref<ApiEffortEntriesShortGetCollectionResponse["hydra:member"]>
    > {
      options = storeMethodArgumentsCompatibilityLayer(arguments, "findAll");
      options = defaultRequestOptionsMerge(options);
      payload ??= {};
      payload.query ??= {};
      payload.query.page ??= 1;
      payload.query.itemsPerPage ??= 100;
      if (payload.query.itemsPerPage === 0) return ref([]);
      if (options?.context) payload.query.context = options.context;
      if (options?.forceRefresh)
        await this.$cache.delete(payload, "collection");
      const res = await this.$cache.getOrCreate<
        ApiEffortEntriesShortGetCollectionResponse["hydra:member"]
      >(
        payload,
        async () => {
          const promise =
            (await apiEffortEntriesShortGetCollection<ThrowGlobalError>({
              ...payload,
              ...(options?.context
                ? { query: { context: options?.context } }
                : {}),
              throwOnError: options.throwGlobalError,
            })) as AxiosResponse<
              ApiEffortEntriesShortGetCollectionResponse["hydra:member"]
            >;
          if (!(promise.status >= 200 && promise.status < 300))
            throw new Error("ERROR_SKIP_CACHE", { cause: promise });
          return promise.data["hydra:member"]
            ? Array.from(promise.data["hydra:member"])
            : [];
        },
        "collection",
      );
      if (typeof res.value === "object" && !payload.query["properties[]"]) {
        const data =
          res.value as ApiEffortEntriesShortGetCollectionResponse["hydra:member"];
        await Promise.all(
          data.map((jsonld) => {
            if (jsonld["@id"]) {
              return this.$cache.set(iri2id(jsonld["@id"]), jsonld, "item");
            }
          }),
        );
      }
      return res as Ref<
        ApiEffortEntriesShortGetCollectionResponse["hydra:member"]
      >;
    },
    async findAllShortHydra<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortEntriesShortGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ): Promise<Ref<ApiEffortEntriesShortGetCollectionResponse>> {
      payload ??= {};
      payload.query ??= {};
      payload.query.page ??= 1;
      payload.query.itemsPerPage ??= 100;
      if (options?.context) payload.query.context = options.context;
      if (options?.forceRefresh) await this.$cache.delete(payload, "hydra");
      const res =
        await this.$cache.getOrCreate<ApiEffortEntriesShortGetCollectionResponse>(
          payload,
          async () => {
            const d =
              await apiEffortEntriesShortGetCollection<ThrowGlobalError>(
                payload,
              ).then((d) => d.data);
            return d;
          },
          "hydra",
        );
      if (typeof res.value === "object" && !payload.query["properties[]"]) {
        const data = res.value["hydra:member"];
        await Promise.all(
          data.map((jsonld) => {
            if (jsonld["@id"]) {
              return this.$cache.set(iri2id(jsonld["@id"]), jsonld, "item");
            }
          }),
        );
      }
      return res;
    },
    async findShort<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortEntriesShortGetCollectionData,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(arguments, "find");
      if (!payload) payload = { query: {} };
      if (!payload.query) payload.query = {};
      payload.query.page = 1;
      payload.query.itemsPerPage = 1;
      if (options?.context) payload.query.context = options.context;
      const res = await this.findAll<ThrowGlobalError>(payload, options);
      if (res.value.length > 1)
        logger.warn("Find() returned more than one result!");
      return computed(() => (res.value.length > 0 ? res.value[0] : undefined));
    },
    /* {"name":"apiEffortEntriesShortGetCollection","tag":"EffortEntry","storeName":"EffortEntry","requestType":"ApiEffortEntriesShortGetCollectionData","responseType":"ApiEffortEntriesShortGetCollectionResponse","errorType":"unknown","apiFunctionName":"apiEffortEntriesShortGetCollection","requestImportName":"ApiEffortEntriesShortGetCollectionData","responseImportName":"ApiEffortEntriesShortGetCollectionResponse","actionType":"collection","actionName":"fetchAll","friendlyName":"fetchAll","suffix":"Short"} */
    async findAllShortWithPagination<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortEntriesShortGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "findAllWithPagination",
      );
      const result = await this.findAllShortHydra<ThrowGlobalError>(
        payload,
        options,
      );
      return HydraToPagination<(typeof result.value)["hydra:member"][number]>(
        result,
      );
    },
    async findAllShortAsIriDictionary<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortEntriesShortGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "findAllAsIriDictionary",
      );
      const result = await this.findAllShortHydra<ThrowGlobalError>(
        payload,
        options,
      );
      return HydraToIriDictionary<
        (typeof result.value)["hydra:member"][number]
      >(result);
    },
    async findAllShortAsMap<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortEntriesShortGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "findAllAsMap",
      );
      const result = await this.findAllShortHydra<ThrowGlobalError>(
        payload,
        options,
      );
      return HydraToIriMap<(typeof result.value)["hydra:member"][number]>(
        result,
      );
    },
    /**
{"name":"apiEffortEntriesUnsyncedGetCollection","tag":"EffortEntry","storeName":"EffortEntry","requestType":"ApiEffortEntriesUnsyncedGetCollectionData","responseType":"ApiEffortEntriesUnsyncedGetCollectionResponse","errorType":"unknown","apiFunctionName":"apiEffortEntriesUnsyncedGetCollection","requestImportName":"ApiEffortEntriesUnsyncedGetCollectionData","responseImportName":"ApiEffortEntriesUnsyncedGetCollectionResponse","actionType":"collection","actionName":"fetchAll","friendlyName":"fetchAll","suffix":"Unsynced"}
*/
    async findAllUnsynced<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortEntriesUnsyncedGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ): Promise<
      Ref<ApiEffortEntriesUnsyncedGetCollectionResponse["hydra:member"]>
    > {
      options = storeMethodArgumentsCompatibilityLayer(arguments, "findAll");
      options = defaultRequestOptionsMerge(options);
      payload ??= {};
      payload.query ??= {};
      payload.query.page ??= 1;
      payload.query.itemsPerPage ??= 100;
      if (payload.query.itemsPerPage === 0) return ref([]);
      if (options?.context) payload.query.context = options.context;
      if (options?.forceRefresh)
        await this.$cache.delete(payload, "collection");
      const res = await this.$cache.getOrCreate<
        ApiEffortEntriesUnsyncedGetCollectionResponse["hydra:member"]
      >(
        payload,
        async () => {
          const promise =
            (await apiEffortEntriesUnsyncedGetCollection<ThrowGlobalError>({
              ...payload,
              ...(options?.context
                ? { query: { context: options?.context } }
                : {}),
              throwOnError: options.throwGlobalError,
            })) as AxiosResponse<
              ApiEffortEntriesUnsyncedGetCollectionResponse["hydra:member"]
            >;
          if (!(promise.status >= 200 && promise.status < 300))
            throw new Error("ERROR_SKIP_CACHE", { cause: promise });
          return promise.data["hydra:member"]
            ? Array.from(promise.data["hydra:member"])
            : [];
        },
        "collection",
      );
      if (typeof res.value === "object" && !payload.query["properties[]"]) {
        const data =
          res.value as ApiEffortEntriesUnsyncedGetCollectionResponse["hydra:member"];
        await Promise.all(
          data.map((jsonld) => {
            if (jsonld["@id"]) {
              return this.$cache.set(iri2id(jsonld["@id"]), jsonld, "item");
            }
          }),
        );
      }
      return res as Ref<
        ApiEffortEntriesUnsyncedGetCollectionResponse["hydra:member"]
      >;
    },
    async findAllUnsyncedHydra<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortEntriesUnsyncedGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ): Promise<Ref<ApiEffortEntriesUnsyncedGetCollectionResponse>> {
      payload ??= {};
      payload.query ??= {};
      payload.query.page ??= 1;
      payload.query.itemsPerPage ??= 100;
      if (options?.context) payload.query.context = options.context;
      if (options?.forceRefresh) await this.$cache.delete(payload, "hydra");
      const res =
        await this.$cache.getOrCreate<ApiEffortEntriesUnsyncedGetCollectionResponse>(
          payload,
          async () => {
            const d =
              await apiEffortEntriesUnsyncedGetCollection<ThrowGlobalError>(
                payload,
              ).then((d) => d.data);
            return d;
          },
          "hydra",
        );
      if (typeof res.value === "object" && !payload.query["properties[]"]) {
        const data = res.value["hydra:member"];
        await Promise.all(
          data.map((jsonld) => {
            if (jsonld["@id"]) {
              return this.$cache.set(iri2id(jsonld["@id"]), jsonld, "item");
            }
          }),
        );
      }
      return res;
    },
    async findUnsynced<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortEntriesUnsyncedGetCollectionData,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(arguments, "find");
      if (!payload) payload = { query: {} };
      if (!payload.query) payload.query = {};
      payload.query.page = 1;
      payload.query.itemsPerPage = 1;
      if (options?.context) payload.query.context = options.context;
      const res = await this.findAll<ThrowGlobalError>(payload, options);
      if (res.value.length > 1)
        logger.warn("Find() returned more than one result!");
      return computed(() => (res.value.length > 0 ? res.value[0] : undefined));
    },
    /* {"name":"apiEffortEntriesUnsyncedGetCollection","tag":"EffortEntry","storeName":"EffortEntry","requestType":"ApiEffortEntriesUnsyncedGetCollectionData","responseType":"ApiEffortEntriesUnsyncedGetCollectionResponse","errorType":"unknown","apiFunctionName":"apiEffortEntriesUnsyncedGetCollection","requestImportName":"ApiEffortEntriesUnsyncedGetCollectionData","responseImportName":"ApiEffortEntriesUnsyncedGetCollectionResponse","actionType":"collection","actionName":"fetchAll","friendlyName":"fetchAll","suffix":"Unsynced"} */
    async findAllUnsyncedWithPagination<
      ThrowGlobalError extends boolean = true,
    >(
      payload: ApiEffortEntriesUnsyncedGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "findAllWithPagination",
      );
      const result = await this.findAllUnsyncedHydra<ThrowGlobalError>(
        payload,
        options,
      );
      return HydraToPagination<(typeof result.value)["hydra:member"][number]>(
        result,
      );
    },
    async findAllUnsyncedAsIriDictionary<
      ThrowGlobalError extends boolean = true,
    >(
      payload: ApiEffortEntriesUnsyncedGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "findAllAsIriDictionary",
      );
      const result = await this.findAllUnsyncedHydra<ThrowGlobalError>(
        payload,
        options,
      );
      return HydraToIriDictionary<
        (typeof result.value)["hydra:member"][number]
      >(result);
    },
    async findAllUnsyncedAsMap<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortEntriesUnsyncedGetCollectionData | null,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "findAllAsMap",
      );
      const result = await this.findAllUnsyncedHydra<ThrowGlobalError>(
        payload,
        options,
      );
      return HydraToIriMap<(typeof result.value)["hydra:member"][number]>(
        result,
      );
    },

    async fetchAllByIri<ThrowGlobalError extends boolean = true>(
      iris: string[],
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "fetchAllByIri",
      );
      const result: Ref<unknown[]> = ref([]);
      const iriCheck = checkIriArray(iris, this.$iriPrefix);
      if (iriCheck.inputCnt != iriCheck.outputCnt)
        logger.warn(
          `At least one given iri is not valid or does not match api prefix (${this.$iriPrefix})!`,
          iris,
        );
      if (iriCheck.outputCnt == 0) return result;
      const allIds = iriCheck.iris.map((iri) => fromIri<string>(iri)?.id!);
      const dataset = options?.forceRefresh
        ? allIds.map((id) => [id, undefined])
        : await Promise.all(
            allIds.map(async (id) => [id, await this.$cache.get(id, "item")]),
          );
      const missingInCache = dataset
        .filter((pair) => !pair[1])
        .map((pair) => pair[0]);
      const fetched = await this.findAll<ThrowGlobalError>(
        {
          query: {
            itemsPerPage: missingInCache.length,
            "id[]": missingInCache as string[],
          },
        },
        options,
      ).then((d) => d.value);
      //now rebuild return
      for (const id of allIds) {
        const dsMatch = dataset.find((pair) => pair[0] == id) as unknown[];
        if (dsMatch[1]) {
          result.value.push(dsMatch[1]);
          continue;
        }
        if (fetched && fetched.length > 0) {
          /*
           */
          const fetchedItem = fetched.find(
            (itm) => (itm.id as string) == (id as string),
          );
          if (!fetchedItem) {
            debugger;
          }
          result.value.push(fetchedItem);
        }
      }
      return result;
    },

    async fetchAllByIriAsDictionary<ThrowGlobalError extends boolean = true>(
      iris: string[],
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "fetchAllByIriAsDictionary",
      );
      const data = await this.fetchAllByIri<ThrowGlobalError>(iris, options);
      const res = keyBy(
        data.value,
        (e: ApiEffortEntriesIdGetResponse) => e["@id"],
      ) as Record<string, ApiEffortEntriesIdGetResponse>;
      return readonly(ref(res));
    },
    async fetchAllByIriAsMap<ThrowGlobalError extends boolean = true>(
      iris: string[],
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(
        arguments,
        "fetchAllByIriAsMap",
      );
      const result = new Map<string, ApiEffortEntriesIdGetResponse>();
      const rawData = await this.fetchAllByIri<ThrowGlobalError>(iris, options);
      const data = keyBy(
        rawData.value,
        (e: ApiEffortEntriesIdGetResponse) => e["@id"],
      ) as Record<string, ApiEffortEntriesIdGetResponse>;
      forEach(data, (v: ApiEffortEntriesIdGetResponse, k: string) =>
        result.set(k, v),
      );
      return readonly(ref(result));
    },

    /* {"name":"apiEffortEntriesPost","tag":"EffortEntry","storeName":"EffortEntry","requestType":"ApiEffortEntriesPostData","responseType":"ApiEffortEntriesPostResponse","errorType":"ApiEffortEntriesPostError","apiFunctionName":"apiEffortEntriesPost","requestImportName":"ApiEffortEntriesPostData","responseImportName":"ApiEffortEntriesPostResponse","actionType":"post","actionName":"post","friendlyName":"post","suffix":""} */
    async post<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortEntriesPostData,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(arguments, "post");
      options = defaultRequestOptionsMerge(options);
      return await apiEffortEntriesPost<ThrowGlobalError>({
        ...payload,
        throwOnError: options.throwGlobalError,
      }).then((d) => d.data);
    },

    /* {"name":"apiEffortEntriesIdPut","tag":"EffortEntry","storeName":"EffortEntry","requestType":"ApiEffortEntriesIdPutData","responseType":"ApiEffortEntriesIdPutResponse","errorType":"ApiEffortEntriesIdPutError","apiFunctionName":"apiEffortEntriesIdPut","requestImportName":"ApiEffortEntriesIdPutData","responseImportName":"ApiEffortEntriesIdPutResponse","actionType":"update","actionName":"put","friendlyName":"put","identifierName":"id","identifierType":"string","suffix":"Id","identifierNameCapitalized":"Id"} */
    async putId<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortEntriesIdPutData,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(arguments, "put");
      options = defaultRequestOptionsMerge(options);
      if (isIri(payload.path.id)) {
        payload.path.id = iri2id(payload.path.id);
        console.log("IRI given where Id was expected! Please fix!");
      }
      return await apiEffortEntriesIdPut<ThrowGlobalError>({
        ...payload,
        throwOnError: options.throwGlobalError,
      }).then((d) => d.data);
    },

    async delete<ThrowGlobalError extends boolean = true>(
      payload: ApiEffortEntriesIdDeleteData,
      options?: RequestOptions<ThrowGlobalError>,
    ) {
      options = storeMethodArgumentsCompatibilityLayer(arguments, "delete");
      options = defaultRequestOptionsMerge(options);
      const res = await apiEffortEntriesIdDelete<ThrowGlobalError>({
        ...payload,
        throwOnError: options.throwGlobalError,
      });
      await this.$cache.delete(payload, "item");
      return res;
    },
  },
});
